module.exports = __webpack_public_path__ + "media/images/emblems/Vinelz-coat_of_arms-02278fd7bf33b80a6d154650e44d0665.svg";